import { Box } from '@mui/material';
import type { CSSProperties } from '@mui/material/styles/createMixins';
import lottie from 'lottie-web';
import type { FC } from 'react';
import { createRef, useEffect } from 'react';

export interface PlayerProps {
  className?: string;
  src: string;
  sx: CSSProperties;
}

export const LottiePlayer: FC<PlayerProps> = ({ className, src, sx }) => {
  const container = createRef<HTMLDivElement>();

  useEffect(() => {
    if (!container.current) return;

    const instance = lottie.loadAnimation({
      autoplay: true,
      container: container.current,
      loop: true,
      path: src,
      renderer: 'svg',
    });

    return () => instance.destroy();
  }, [container, src]);

  return (
    <Box
      className={className}
      id="lottie"
      ref={container}
      style={{
        margin: '0 auto',
        outline: 'none',
        overflow: 'hidden',
      }}
      sx={sx}
    />
  );
};
